export default (o: { [key: string]: any }) => Object.keys(o).some((key: string) => o[key] !== 0 && !o[key]);
